import { useEffect, useState } from 'react';

export default function InputTextarea({
  label,
  inputId,
  placeholder,
  value = '',
  setValue = '',
  required = false,
  isValid,
  setIsValid = () => {},
  externalError = '',
}) {
  const [validText, setValidText] = useState('');

  useEffect(() => {
    if (required && !value?.trim()) {
      setValidText('필수 입력 값입니다.');
      return;
    }
    setValidText('');
  }, [required, value]);

  const displayError = externalError || validText;
  const hasError = !!displayError;

  return (
    <div className="w-full flex justify-between items-center mb-2 mt-4">
      <label htmlFor={inputId} className="w-1/5 text-explorer font-semibold text-base">
        {label} <span className="text-giver align-middle">{required ? '*' : ''}</span>
      </label>
      <textarea
        id={inputId}
        type="text"
        placeholder={placeholder}
        rows={10}
        className={`w-3/5 rounded-lg py-1 px-3 resize-none ${hasError ? 'border-2 border-red-500' : ''}`}
        value={value}
        onChange={async (e) => {
          setValue(e.target.value);

          if (e.target.value.trim()) {
            return setIsValid(true);
          }

          setIsValid(false);
        }}
      />
      <span className="ml-4 w-1/5 text-red-400 text-sm">{displayError}</span>
    </div>
  );
}
